import React, { FC } from 'react';
import styles from './EarlyCancellationFee.module.scss';
import { usePaymentsToggle } from 'components/Cart/OrderSummary/PaymentsToggle/usePaymentsToggle/usePaymentsToggle';
import { useContentfulEarlyCancellationFeeQuery } from './useContentfulEarlyCancellationFeeQuery/useContentfulEarlyCancellationFeeQuery';
import { TextWithPaymentsComparisonLink } from 'components/PaymentsComparisonLink/utils/TextWithPaymentsComparisonLink';

export const EarlyCancellationFee: FC = () => {
  const { isPayMonthly } = usePaymentsToggle();

  const earlyCancellationFeeQuery = useContentfulEarlyCancellationFeeQuery();

  const { data: contentfulSubscriptionEarlyCancellationTerms } = earlyCancellationFeeQuery;

  const earlyCancellationTermsData = contentfulSubscriptionEarlyCancellationTerms?.[0];
  const blurb = earlyCancellationTermsData?.earlyCancellationTermsBlurb?.blurb;
  const link = earlyCancellationTermsData?.earlyCancellationTermsBlurb?.link;

  if (!isPayMonthly || !earlyCancellationTermsData || !blurb) {
    return null;
  }

  return (
    <div className={styles.container}>
      <TextWithPaymentsComparisonLink className={styles.link} text={blurb} link={link?.title} />
    </div>
  );
};
